export default __webpack_public_path__ + "static/media/bQ.4db6873d.svg";